import React from 'react';

import {
  actionNames,
  actionPrefixes,
  eventTypes,
  objectTypes,
  useTracker,
} from '@newsela/snitch';
import PropTypes from 'prop-types';

import {
  reportsMenuPopoutContainer
} from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/ResourceMenus/ReportsMenu/ReportsMenuPopout/ReportsMenuPopout.styles';
import {
  PopoutMenuSection
} from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/shared/PopoutMenuSection';
import {
  PopoutSectionItem
} from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/shared/PopoutSectionItem';

import {useGetReportsMenuSectionProps} from '../../../shared/hooks/useGetReportsMenuSectionProps';

const propTypes = {
  user: PropTypes.object,
};

const getEntityForUserRole = (user) => {
  if ('district_admin' in user && user.district_admin.district) {
    return {
      entityType: 'district',
      entityId: user.district_admin.district.unique_id,
    };
  } else if ('school_admin' in user && user.school_admin.school) {
    return {
      entityType: 'school',
      entityId: user.school_admin.school.unique_id,
    };
  } else {
    return {
      entityType: 'school',
      entityId: user.schools[0]?.unique_id ?? '',
    };
  }
};

const ReportsMenuPopout = ({user}) => {
  const {
    reportsMenuSectionTitle,
    reportsMenuSectionItems,
  } = useGetReportsMenuSectionProps();
  const {trackAction, getEventName} = useTracker();
  const {entityId, entityType} = getEntityForUserRole(user);

  const handleItemClick = (title) => {
    trackAction({
      event_name: getEventName(
        objectTypes.user,
        actionPrefixes.initiate,
        actionNames.navigate,
      ),
      event_type: eventTypes.click,
      dimension_properties: {
        description: `Navigates to ${title} page using the global nav menu."`,
        metadata: {
          entityId,
          entityType,
          userRoles: user?.roles ?? [],
        },
      },
    });
  };

  return (
    <div className={reportsMenuPopoutContainer}>
      <PopoutMenuSection width="20rem" title={reportsMenuSectionTitle}>
        {reportsMenuSectionItems.map(({title, href, SvgComponent, dataQASelector}, index) => (
          <PopoutSectionItem
            key={index}
            href={href}
            title={title}
            SvgComponent={SvgComponent}
            dataQASelector={dataQASelector}
            onClick={handleItemClick}
          />
        ))}
      </PopoutMenuSection>
    </div>
  );
};

ReportsMenuPopout.propTypes = propTypes;
ReportsMenuPopout.displayName = 'ReportsMenuPopout';
export {ReportsMenuPopout};
